import { useEffect } from "preact/hooks";

const TERM_ID = "cd6c7374-94b4-4c80-b009-43b0c2f46392";

export default function PrivacyPolicy({ showCloseButton = false, onClose }) {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://app.termly.io/embed-policy.min.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);
  return (
    <div style={{ position: "relative", width: "100%" }}>
      {showCloseButton && (
        <button
          onClick={onClose}
          className="text-white bg-blue-500"
          style={{
            position: "fixed",
            top: "10px",
            right: "10px",
            color: "white",
            border: "none",
            borderRadius: "5px",
            padding: "5px 10px",
            cursor: "pointer",
          }}
        >
          Close
        </button>
      )}
      <div
        name="termly-embed"
        data-id={TERM_ID}
        data-type="iframe"
        style={{ width: "100%" }}
      ></div>
    </div>
  );
}
